import React from "react"
import { graphql } from "gatsby"
import { Link } from "../../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../custom-structured-text-renderer"
import FormComponent from "../../form"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import parse from "html-react-parser"

const Contact = ({ title, richContent, phone, subtitle, form, slug }) => {
  const [current, setCurrent] = React.useState(0)
  const elementRef = React.useRef(null)

  React.useEffect(() => {
    const line = elementRef.current?.querySelectorAll(".line")

    ScrollTrigger.create({
      trigger: elementRef.current,
      start: "top bottom",
      onEnter: () => {
        line.forEach((el) => el.classList.add("is-inview"))
      },
    })

    return () => {}
  }, [slug])

  return (
    <section className="contact" ref={elementRef}>
      <div className="contact__inner">
        <div className="contact__left">
          {subtitle && <span>{parse(subtitle)}</span>}
          {phone && <Link to={`tel:${phone}`}>{phone}</Link>}
          {richContent && <StructuredText data={richContent} />}
        </div>
        <div className="contact__right">
          <div className="line line--vertical center-top"></div>
          {title && <h2>{parse(title)}</h2>}

          <form className="contact__switch">
            <h3>What can we help you with?</h3>
            <ul className='form__radio'>
              {form?.length > 0 &&
                form.map((el, i) => (
                  <li key={i}>
                    <input
                      id={el.title}
                      onChange={() => setCurrent(i)}
                      checked={current === i}
                      value={el.title}
                      type="radio"
                      name="enquiry"
                    />
                    <label htmlFor={el.title}>{el.title}</label>
                  </li>
                ))}
            </ul>
          </form>
          <div className="contact__forms">
            {form?.length > 0 && (
              <>
                <div
                  className={`form-container ${current === 0 ? "active" : "inactive"}`}
                >
                  <FormComponent form={form[0]} />
                </div>
                <div
                  className={`form-container ${current === 1 ? "active" : "inactive"}`}
                >
                  <FormComponent form={form[1]} />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}
export default Contact

export const query = graphql`
fragment ContactProps on DatoCmsContact {
  ... on DatoCmsContact {
    id
    title
    subtitle
    richContent {
      value
    }
    phone
    form {
      ...FormProps
    }
  }
}
`
